import { useLocation } from 'react-router-dom';
import TextField from '../../../../../core/common/textFields/TextField';
import dayjs from 'dayjs';

const DescriptionTab = ({ formik }: any) => {
    const location = useLocation();
    const isReadOnly = location.pathname.includes('/projects/view-project');

    return (
        <div className="row">
            <div className="col-md-6 col-lg-4">
                <div className='card'>
                    <div className='card-body'>
                        <h4 className='fw-bold mb-3'>Description:</h4>
                        <div className='row'>
                            <div className="col-md-12">
                                <TextField
                                    label="Description"
                                    type="text"
                                    required
                                    {...formik.getFieldProps("opportunityDetailsDescription.description")}
                                    disabled
                                />
                            </div>
                            <div className="col-md-12">
                                <TextField
                                    label="Analysis"
                                    type="text"
                                    {...formik.getFieldProps("opportunityDetailsDescription.analysis")}
                                    disabled
                                />
                            </div>
                            <div className="col-md-12">
                                <TextField
                                    label="Status"
                                    type="text"
                                    {...formik.getFieldProps("opportunityDetailsDescription.status")}
                                    disabled
                                />
                            </div>
                            <div className="col-md-12">
                                <TextField
                                    label="Status Details"
                                    type="text"
                                    {...formik.getFieldProps("opportunityDetailsDescription.statusDetails")}
                                    disabled
                                />
                            </div>
                            <div className="col-md-12">
                                <TextField
                                    label="Job Type"
                                    type="text"
                                    required
                                    {...formik.getFieldProps("opportunityDetailsDescription.jobType.value")}
                                    disabled
                                />
                            </div>
                            <div className="col-md-12">
                                <TextField
                                    label="Est. Sales Amount"
                                    type="text"
                                    {...formik.getFieldProps("opportunityDetailsDescription.saleAmount")}
                                    disabled
                                />
                            </div>
                            <div className="col-md-12">
                                <TextField
                                    label="Lead Source"
                                    type="text"
                                    {...formik.getFieldProps("opportunityDetailsDescription.leadSource")}
                                    disabled
                                />
                            </div>
                            <div className="col-md-12">
                                <TextField
                                    label="Source Description"
                                    type="text"
                                    {...formik.getFieldProps("opportunityDetailsDescription.sourceDescription")}
                                    disabled
                                />
                            </div>
                            <div className="col-md-12">
                                <TextField
                                    label="Ad Code"
                                    type="text"
                                    {...formik.getFieldProps("opportunityDetailsDescription.adCode")}
                                    disabled
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="col-md-6 col-lg-4">
                <div className='card'>
                    <div className='card-body'>
                        <h4 className='fw-bold mb-3'>Property Address:</h4>
                        <div className='row'>
                            <div className="col-md-12">
                                <TextField
                                    label="Address Line 1"
                                    type="text"
                                    {...formik.getFieldProps("opportunityDetailsPropertyAddress.addressLine1")}
                                    disabled
                                />
                            </div>
                            <div className="col-md-12">
                                <TextField
                                    label="Address Line 2"
                                    type="text"
                                    {...formik.getFieldProps("opportunityDetailsPropertyAddress.addressLine2")}
                                    disabled
                                />
                            </div>
                            <div className="col-md-12">
                                <TextField
                                    label="City"
                                    type="text"
                                    {...formik.getFieldProps("opportunityDetailsPropertyAddress.city")}
                                    disabled
                                />
                            </div>
                            <div className="col-md-12">
                                <TextField
                                    label="State/Region"
                                    type="text"
                                    {...formik.getFieldProps("opportunityDetailsPropertyAddress.state")}
                                    disabled
                                />
                            </div>
                            <div className="col-md-12">
                                <TextField
                                    label="ZipCode"
                                    type="text"
                                    {...formik.getFieldProps("opportunityDetailsPropertyAddress.zipCode")}
                                    disabled
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="col-md-6 col-lg-4">
                <div className='card'>
                    <div className='card-body'>
                        <h4 className='fw-bold mb-3'>Appointment Details:</h4>
                        <div className='row'>
                            <div className="col-md-12">
                                <TextField
                                    label="1st Contact Dt"
                                    type="text"
                                    // {...formik.getFieldProps("opportunityDetailsAppointment.firstContactDate")}
                                      value={
                                        formik?.values?.opportunityDetailsAppointment?.firstContactDate
                                            ? dayjs(formik.values.opportunityDetailsAppointment.firstContactDate).format('MMM-DD-YYYY')
                                            : "No Date Available"
                                    }
                                    disabled
                                />
                            </div>
                            <div className="col-md-12">
                                <TextField
                                    label="1st Appt. Date"
                                    type="text"
                                    // {...formik.getFieldProps("opportunityDetailsAppointment.firstAptDate")}
                                    value={
                                        formik?.values?.opportunityDetailsAppointment?.firstAptDate
                                            ? dayjs(formik.values.opportunityDetailsAppointment.firstAptDate).format('MMM-DD-YYYY')
                                            : "No Date Available"
                                    }
                                    disabled
                                />
                            </div>
                            <div className="col-md-12">
                                <TextField
                                    label="Appt. Maker"
                                    type="text"
                                    {...formik.getFieldProps("opportunityDetailsAppointment.appointmentMaker.value")}
                                    disabled
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className='col-md-12 d-flex justify-content-end '>
                <div className='mt-2 bg-red text-redd position-fixed bottom-0 px-2 rounded' style={{ right: "0px" }}><i>Created at 11/17/2023 by Ann Marie.01:00:22 PM Last modified at 11/17/2023 01:00:22 PM by Maxx Klein.</i></div>
            </div>
        </div>

    )
}

export default DescriptionTab